



























































import { Vue, Component } from "vue-property-decorator";
import PanelDetectionWaiting from "@/components/PanelDetectionWaiting.vue";
import { State } from "vuex-class";
import { DetectState } from "./_state";
import { AxiosDefault } from "@/plugins/axios";
import { ROMPresetAppItem } from "../../modules/apk/apk.interface";
import { Utils } from "@/plugins/utils";

declare module "vue/types/vue" {
  interface Vue {
    selectedValue: string;
  }
}

@Component({
  components: {
    PanelDetectionWaiting
  },
  metaInfo: {
    title: "APK 自动化检测"
  },
  data() {
    return {
      selectedValue: "",
      confirm: false,
      options: []
    };
  },
  methods: {
    onFilter(val) {
      this.selectedValue = val;
    },
    onSubmit() {
      let param = this.$route.query.id;
      this.$router.push(`/detect/checklog?id=${param}`);
    },
    onSubmitDown() {
      Utils.download(this.selectedValue, this.selectedValue);
    }
  },
  computed: {
    contentType() {
      return this.$route.query.id === "ROM"
        ? "ROM LOG 隐私检测"
        : "APK LOG 隐私检测";
    }
  }
})
export default class extends Vue {
  options: ROMPresetAppItem[] | null = null;
  get waitingDetection() {
    return DetectState.waitingDetection;
  }
  goBack() {
    this.$router.push("/detect/chooseType");
  }
  async created() {
    let AppList = await AxiosDefault.get("/bff/rule/romList");
    this.options = AppList.data;
  }
}
